import { __rest, __assign } from '../../../_virtual/_tslib.js';
import React, { useState } from 'react';
import classnames from 'classnames';
import CircleLoader from '../../Loader/CircleLoader/index.js';
import { SingleDatePicker, toMomentObject } from 'react-dates';
import styles from '../styles.css.js';
import CalendarIcon from '../calendar.svg.js';
import ErrorIcon from '../error.svg.js';
import ValidIcon from '../valid.svg.js';

var SingleDatePickerContainer = function SingleDatePickerContainer(_a) {
  var _b, _c, _d;

  var id = _a.id,
      date = _a.date,
      className = _a.className,
      label = _a.label,
      _e = _a.numberOfMonths,
      numberOfMonths = _e === void 0 ? 1 : _e,
      _f = _a.hideIcon,
      hideIcon = _f === void 0 ? true : _f,
      _g = _a.allowPreviousDates,
      allowPreviousDates = _g === void 0 ? false : _g,
      _h = _a.labelHidden,
      labelHidden = _h === void 0 ? false : _h,
      _onFocusChange = _a.onFocusChange,
      _j = _a.openDirection,
      openDirection = _j === void 0 ? 'down' : _j,
      _k = _a.error,
      error = _k === void 0 ? false : _k,
      withFullScreenPortal = _a.withFullScreenPortal,
      keepOpenOnDateSelect = _a.keepOpenOnDateSelect,
      _onDateChange = _a.onDateChange,
      _onClose = _a.onClose,
      errorText = _a.errorText,
      helpText = _a.helpText,
      valid = _a.valid,
      loading = _a.loading,
      disabled = _a.disabled,
      rest = __rest(_a, ["id", "date", "className", "label", "numberOfMonths", "hideIcon", "allowPreviousDates", "labelHidden", "onFocusChange", "openDirection", "error", "withFullScreenPortal", "keepOpenOnDateSelect", "onDateChange", "onClose", "errorText", "helpText", "valid", "loading", "disabled"]);

  var _l = useState(false),
      focused = _l[0],
      setFocused = _l[1];

  var hasError = !!errorText || error;
  var hasHelpText = !!helpText;
  var isValid = valid && !hasError;
  var ComponentIcon = React.createElement(CalendarIcon, null);

  if (hasError) {
    ComponentIcon = React.createElement(ErrorIcon, {
      className: styles.errorIcon
    });
  } else if (isValid) {
    ComponentIcon = React.createElement(ValidIcon, {
      className: styles.validIcon
    });
  } else if (loading) {
    ComponentIcon = React.createElement(CircleLoader, {
      color: "#087bcc",
      size: "16px",
      thickness: "2px",
      className: styles.loadingIcon
    });
  }

  return React.createElement("div", {
    className: styles.field
  }, React.createElement("div", {
    className: styles.inputContainer
  }, !labelHidden && label && React.createElement("label", {
    id: "label-" + id,
    htmlFor: id,
    className: classnames(styles.label, (_b = {}, _b[styles.hasError] = hasError, _b))
  }, label), React.createElement("div", {
    className: styles.innerInputContainer
  }, React.createElement("div", {
    "data-testid": "single-date-picker",
    className: classnames(styles.datePicker, (_c = {}, _c[styles.openDown] = openDirection === 'down', _c[styles.openUp] = openDirection === 'up', _c[styles.multiMonth] = numberOfMonths > 1, _c[styles.hasFocus] = focused, _c[styles.hasError] = hasError, _c[styles.isValid] = isValid, _c), className)
  }, React.createElement(SingleDatePicker, __assign({
    id: id,
    readOnly: true,
    openDirection: openDirection,
    numberOfMonths: numberOfMonths,
    inputIconPosition: 'after',
    showDefaultInputIcon: !hideIcon,
    hideKeyboardShortcutsPanel: true,
    withFullScreenPortal: withFullScreenPortal,
    keepOpenOnDateSelect: withFullScreenPortal ? false : keepOpenOnDateSelect,
    customInputIcon: ComponentIcon,
    date: !!date ? toMomentObject(new Date(date), 'LLLL') : null,
    focused: focused,
    disabled: disabled,
    isOutsideRange: allowPreviousDates ? function () {
      return false;
    } : undefined,
    onDateChange: function onDateChange(date) {
      if (date && _onDateChange) {
        var formattedDate = date.toDate();

        _onDateChange(formattedDate);
      }
    },
    onFocusChange: function onFocusChange(_a) {
      var focused = _a.focused;
      setFocused(focused || false);
      _onFocusChange && _onFocusChange(focused);
    },
    onClose: function onClose(_a) {
      var startDate = _a.startDate,
          endDate = _a.endDate;
      _onClose && _onClose({
        startDate: startDate.toDate(),
        endDate: endDate.toDate()
      });
    }
  }, rest)))), hasError && React.createElement("div", {
    className: styles.errorText
  }, errorText), hasHelpText && React.createElement("div", {
    className: classnames(styles.helpText, (_d = {}, _d[styles.lowerText] = !hasError, _d))
  }, helpText)));
};

export default SingleDatePickerContainer;
//# sourceMappingURL=index.js.map
